import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css']
})
export class BreadcrumbComponent implements OnInit {

  breadcrumbs = [];
  currentUrl: String;

  constructor(
    private route: ActivatedRoute,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.translate.use(localStorage.getItem('localLanguage'));

    var breadcrumbData = this.route.snapshot.data.breadcrumb;
    let last = breadcrumbData;

    if (breadcrumbData instanceof Object) {
      last = breadcrumbData.name;

      if (breadcrumbData.parents) breadcrumbData.parents.forEach(breadcrumb => {
        if (breadcrumb.path.indexOf("/") < 0) breadcrumb.path = "/" + breadcrumb.path;
        var idx = this.breadcrumbs.push({
          url: breadcrumb.path,
          label: breadcrumb.name,
          params: this.route.snapshot.root.params
        });

        if (breadcrumb.translate) this.translate.get(breadcrumb.name).subscribe(name => {
          this.breadcrumbs[idx - 1].label = name;
        });
      });
    }

    this.currentUrl = this.route.snapshot.url.toString();
    if (this.currentUrl.indexOf("/") < 0) this.currentUrl = "/" + this.currentUrl;
    var idx = this.breadcrumbs.push({
      url: this.currentUrl,
      label: last,
      params: this.route.snapshot.root.params
    });
    if (breadcrumbData.translate) last = this.translate.get(breadcrumbData.name).subscribe(name => {
      this.breadcrumbs[idx - 1].label = name;
    });
  }
}
